<script>
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: "",
        },
        titoloScheda: {
            type: String,
        }
    },
    mounted() {
        let siteName;
        let documentTitle;
        // Check if $appConfig and nomeSito are defined
        if (this.$appConfig && this.$appConfig.nomeSito) {
            siteName = this.$appConfig.nomeSito;
        } else {
            siteName = 'Default Site Name';
        }
        if (this.title) {
            documentTitle = `${this.title} - ${siteName}`;
        } else if (this.titoloScheda) {
            documentTitle = `${this.titoloScheda} - ${siteName}`;
        }
        document.title = documentTitle;
    },
};
</script>

<template>
    <BRow class="align-items-center" v-if="title">
        <BCol cols="12">
            <div class="page-title-box d-flex justify-content-between align-items-center">
                <h1 class="mb-sm-0" >{{ title }}</h1>
            </div>
        </BCol>
    </BRow>
</template>
